<script setup lang="ts">
import { useToastNotifications } from "@/composables/useToastNotifications";

const { toastNotifications, closeNotification } = useToastNotifications();
</script>

<template>
  <Teleport to="body">
    <div class="absolute right-0 top-0 z-100 w-[440px]">
      <ToastNotification
        v-for="(toastNotification, $index) in toastNotifications"
        :key="toastNotification.id"
        :index="$index"
        :title="toastNotification.title"
        :label="toastNotification.label"
        :type="toastNotification.type"
        :duration="toastNotification.duration"
        @expired="closeNotification($index)"
      >
      </ToastNotification>
    </div>
  </Teleport>
</template>
